export const addAuthToFetchOpts = (accessToken, options) => {
  options.headers = options?.headers || {};
  options.headers['Authorization'] = `Bearer ${accessToken}`;
  options.timeout = 20000;
  return options;
}

export const addAuthToAxiosOpts = addAuthToFetchOpts;

